import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "./index.css";
import { jsx as t, jsxs as e, Fragment as n } from "react/jsx-runtime";
import r from "classnames";
import { CompositeDecorator as a, EditorState as o, convertFromRaw as s, Editor as l } from "draft-js";
import { useRef as c, useState as i, forwardRef as m } from "react";
import { Modal as d } from "@design-system/modal";
import { DangerouslySetInnerHtml as g } from "@phx-husky/dangerously-set-inner-html";
import { useQueryClient as u } from "react-query";
var y, p;
!function (t) {
  t.LINK = "LINK", t.LEGAL_DOCUMENT = "LEGAL-DOCUMENT";
}(y || (y = {})), function (t) {
  t.IMAGE = "IMAGE";
}(p || (p = {}));
var f = _defineProperty({}, p.IMAGE, {
    component: function component(_ref) {
      var _ref$blockProps = _ref.blockProps,
        e = _ref$blockProps.id,
        n = _ref$blockProps.name,
        r = _ref$blockProps.url;
      return t("img", {
        "data-media-id": e,
        alt: n,
        src: r,
        className: "cds-rte-text__image"
      });
    },
    editable: !1
  }),
  E = function E(_ref2) {
    var r = _ref2.entityKey,
      a = _ref2.contentState;
    var o = c(null),
      s = u(),
      _i = i(!1),
      _i2 = _slicedToArray(_i, 2),
      l = _i2[0],
      m = _i2[1],
      _a$getEntity$getData = a.getEntity(r).getData(),
      y = _a$getEntity$getData.legalDocumentId,
      p = _a$getEntity$getData.legalDocumentIdLabel,
      f = s.getQueryData(y),
      E = function E() {
        m(!1), o.current && o.current.focus();
      };
    return e(n, {
      children: [t("button", Object.assign({
        ref: o,
        className: "cds-rte-text__legal-button",
        type: "button",
        onClick: function onClick() {
          return m(!0);
        }
      }, {
        children: p
      })), t(d, Object.assign({
        isShowing: l,
        close: E,
        closeModal: E,
        closeAriaLabel: "Close modal",
        className: "cds-rte-text__legal-modal"
      }, {
        children: (null == f ? void 0 : f.body) ? t(g, {
          html: f.body,
          onClick: function onClick(t) {
            var e = t.target;
            for (; e !== t.currentTarget;) {
              if (e instanceof HTMLAnchorElement) return t.preventDefault(), void window.open(e.href, "_blank");
              e = e.parentElement;
            }
          }
        }) : null
      }))]
    });
  },
  b = function b(_ref3) {
    var e = _ref3.entityKey,
      n = _ref3.contentState,
      r = _ref3.children;
    var _n$getEntity$getData = n.getEntity(e).getData(),
      a = _n$getEntity$getData.url;
    return t("a", Object.assign({
      href: a,
      target: "_blank",
      rel: "noreferrer",
      className: "cds-rte-text__link"
    }, {
      children: r
    }));
  },
  h = function h(t, e, n, r) {
    t.findEntityRanges(function (t) {
      var e = t.getEntity();
      return null !== e && n.getEntity(e).getType() === r;
    }, e);
  },
  N = function N(t, e) {
    var n = t.getType(),
      r = e.getCurrentContent(),
      a = (s = r, (o = t).getEntityAt(0) && s.getEntity(o.getEntityAt(0)));
    var o, s;
    if ("atomic" === n && a) return function (t, e) {
      return f[t] ? Object.assign(Object.assign({}, f[t]), {
        props: e
      }) : null;
    }(a.getType(), a.getData());
  },
  L = m(function (_ref4, c) {
    var e = _ref4.className,
      n = _ref4.text;
    var i = o.createWithContent(s(JSON.parse(n)), new a([{
      strategy: function strategy(t, e, n) {
        return h(t, e, n, y.LINK);
      },
      component: b
    }, {
      strategy: function strategy(t, e, n) {
        return h(t, e, n, y.LEGAL_DOCUMENT);
      },
      component: E
    }]));
    return t("div", Object.assign({
      ref: c,
      className: r("cds-rte-text", e)
    }, {
      children: t(l, {
        editorState: i,
        readOnly: !0,
        blockRendererFn: function blockRendererFn(t) {
          return N(t, i);
        }
      })
    }));
  });
export { L as RTEText };